import { useState, useRef, useEffect } from 'react';
import { X, Play } from 'lucide-react';

const DEMO_VIDEO_URL =
  'https://customer-assets-v7afamib.emergentagent.net/job_whatsapp-api-hub-13/artifacts/fln40t9j_WhatsApp%20Video%202026-07-14%20at%2012.06.37%20AM.mp4';

export { DEMO_VIDEO_URL };

export default function VideoModal({ open, onClose }) {
  const videoRef = useRef(null);

  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && onClose();
    if (open) {
      document.addEventListener('keydown', onKey);
      document.body.style.overflow = 'hidden';
      setTimeout(() => {
        if (videoRef.current) videoRef.current.play().catch(() => {});
      }, 100);
    }
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
      if (videoRef.current) {
        videoRef.current.pause();
        videoRef.current.currentTime = 0;
      }
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4 fade-up"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-4xl bg-black rounded-2xl overflow-hidden shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          aria-label="Close video"
          className="absolute top-3 right-3 z-10 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 text-white grid place-items-center backdrop-blur-md transition-colors"
        >
          <X size={20} />
        </button>
        <video
          ref={videoRef}
          src={DEMO_VIDEO_URL}
          controls
          playsInline
          className="w-full max-h-[80vh] object-contain bg-black"
        >
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  );
}

export function WatchDemoButton({ className = '', children }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={className}
      >
        {children || (
          <>
            <Play size={16} className="mr-2 text-brand-green fill-brand-green" />
            Watch Demo
          </>
        )}
      </button>
      <VideoModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
